export default __webpack_public_path__ + "static/media/DefaultImage.56dbb7a8.png";